import { Form } from "semantic-ui-react";
import './ToggleComponent.scss';

export type ToggleComponentProps = {
    value: boolean;
    setValue: (pageObj: boolean) => void;
    sideLabel: string | React.ReactNode;
    theme: string; // primary secondary tertiary
    topLabel?: string;
    disabled?: boolean;
    requiredField?: boolean; // Optional Property that will add red asterisk to required fields
    toolTipInfo?: string; // Optional Property to show tooltip and point to corresponding tooltip object in json with should be names with a preface of the component type, the component name and then index with a number as needed example (RRSchedule1)
    useBoolean?: boolean // Optional Property to use boolean values instead of the default 1 and 0. NOTE: does not work for objArrays
}

export function ToggleComponent(props: ToggleComponentProps) {
    return (
        <div className="toggle-component-basic">

            <Form.Field>
                <div className="ui form toggle-container">
                    <div className="top-label-div">
                        <label className="top-label">{props.topLabel ? props.topLabel : ''}</label>

                        {
                            (props.topLabel && props.toolTipInfo) &&
                            <div className="tool-tip-entry-icon pl-point5 padding-top-label-tooltip">
                            </div>
                        }

                    </div>
                    <div className="toggle-div">
                        <div className={`field ${props.requiredField ? "required field" : ""} ${props.theme}`}
                            onClick={(e) => props.setValue(!props.value)}>

                            <div className="toggle-wrapper">
                                <div className="ui checkbox toggle">
                                    <input
                                        type="checkbox"
                                        className="hidden"
                                        checked={props.value}
                                        disabled={props.disabled ?? false}
                                    />
                                    <label></label>
                                </div>
                                <div className="toggle-label">{props.sideLabel}</div>
                            </div>
                        </div>
                        {
                            (!props.topLabel && props.toolTipInfo) &&
                            <div className="tool-tip-entry-icon pl-point5 padding-side-label-tooltip">
                            </div>
                        }
                    </div>
                </div>
            </Form.Field>
        </div>
    )
}
